import React from 'react'
import { Link } from 'react-router-dom'

export default function Navigation(props) {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-dark navbar-custom fixed-top">
        <div className="container">
          <a className="navbar-brand logo-image" href="/">
            <img src="images/logo.svg" alt="FALCONEYE AI SOLUTIONS" />
          </a>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarMenu"
            aria-controls="navbarMenu"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-awesome fa fa-bars"></span>
            <span className="navbar-toggler-awesome fa fa-times"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarMenu">
            <ul className="navbar-nav ml-auto">
              <li className="nav-item">
                <a className="nav-link page-scroll" href={props.page === 'home'?"#header":"/"}>
                  HOME <span className="sr-only">(current)</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link page-scroll" href={props.page === 'home'?"#About":"/#About"} >
                  ABOUT
                </a>
              </li>
              {props.page === 'home' && (
              <li className="nav-item">
                <a className="nav-link page-scroll" href="#AI-Solutions">
                  SOLUTIONS
                </a>
              </li>
              )}
              <li className="nav-item">
                <a className="nav-link page-scroll" href={props.page === 'home'?"#roadmap":"/#roadmap"}>
                  ROADMAP
                </a>
              </li>              
              <li className="nav-item">
                <a className="nav-link page-scroll" href={props.page === 'home'?"#team":"/#team"}>
                  TEAM
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link page-scroll" href={props.page === 'home'?"#faq":"/#faq"}>
                  FAQ
                </a>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/terms">
                  TERMS
                </Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/privacy">
                  PRIVACY
                </Link>
              </li>
            </ul>

            <span className="nav-item">
                <a className="btn-solid-reg" href="#contact">Get Started</a>
            </span>
          </div>
        </div>
      </nav>
    </>
  );
}
